/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import {
  // AutoComplete,
  Breadcrumb,
  Col,
  Divider,
  FloatButton,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  //   theme,
} from "antd";
import { MetaTags } from "react-meta-tags";
import {
  CommentOutlined,
  CloseOutlined,
  LoadingOutlined,
  // CloseCircleOutlined,
  // SearchOutlined,
  // DownOutlined,
} from "@ant-design/icons";
import { FaLocationDot } from "react-icons/fa6";
import PackageBanner1 from "../../assets/images/packages-banner1.jpg";
import PackageBanner2 from "../../assets/images/package -banner-2.jpg";
// import PackageBanner3 from "../../assets/images/package-banners-3.jpg";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { useDispatch, useSelector } from "react-redux";
import PackageDetails from "./package-details";
import {
  loadPackagesList,
  loadPackagesTotalList,
} from "../../store/packages/actions";
import { Link } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa6";
import api from "../../helpers";
import { PiPackageBold } from "react-icons/pi";

const Packages = (props) => {
  const [chatModal, setChatModal] = useState(false);
  const media = useMedia();
  const dispatch = useDispatch();
  const history = useHistory();

  const destinationData =
    props && props.location && props.location.state ? props.location.state : "";
  const destinationId = destinationData ? destinationData.destinationId : "";
  console.log(destinationId, "destinationId");
  const categoryId =
    destinationData && destinationData !== undefined ? destinationData._id : "";
  const categoryName =
    destinationData && destinationData !== undefined
      ? destinationData.packageCategoryName
      : "";

  //store integrations
  //filter section
  const [sortingList, setSortingList] = useState([]);
  const [packageTypeList, setPackageTypeList] = useState([]);
  const [durationValue, setDurationValue] = useState([0, 2]);
  const [value, setValue] = useState([0, 0]);
  const [packageLoading, setPackageLoading] = useState(false);
  const slides = [
    {
      id: 1,
      content: (
        <Image
          preview={false}
          src={PackageBanner1}
          height={275}
          style={{
            width: "100%",
            objectFit: "cover",
            display: "block",
          }}
          width={"100%"}
        />
      ),
    },
    // {
    //   id: 2,
    //   content: (
    //     <Image
    //       preview={false}
    //       src={PackageBanner3}
    //       height={345}
    //       style={{
    //         objectFit: "cover",
    //         backgroundPosition: "cover",
    //         display: "block",
    //       }}
    //       width={"100%"}
    //     />
    //   ),
    // },
    {
      id: 3,
      content: (
        <Image
          preview={false}
          src={PackageBanner2}
          height={275}
          style={{
            width: "100%",
            objectFit: "cover",
            display: "block",
          }}
          width={"100%"}
        />
      ),
    },
  ];

  const settings = {
    // className: "center",
    centerMode: true,
    // dots: true, // Show navigation dots
    infinite: slides && slides.length > 1,
    centerPadding: "5px",
    slidesToShow: 1,
    fade: true,
    speed: 1200,
    autoplay: true,
    autoplaySpeed: 2200,
    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
    // slidesToScroll: 1,
    // cssEase: "linear",
    // responsive: [
    //   {
    //     breakpoint: 1024,
    //     settings: {
    //       slidesToShow: 3,
    //       // slidesToScroll: 3,
    //       infinite: slides && slides.length > 1,
    //       dots: true,
    //     },
    //   },
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 2,
    //       // slidesToScroll: 2,
    //       initialSlide: 2,
    //     },
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       slidesToShow: 1,
    //       // slidesToScroll: 1,
    //     },
    //   },
    // ],
  };

  // const payloadData = categoryId `?sortFilter=Newest First`

  useEffect(() => {
    dispatch(loadPackagesList());
    dispatch(loadPackagesTotalList());
    setSortingList({
      label: "Newest First",
      value: "newest-first",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (
      categoryId !== "" &&
      categoryName !== "" &&
      destinationId == undefined
    ) {
      setPackageTypeList({
        label: categoryName,
        value: categoryId,
      });
    }
    if (
      categoryId !== "" &&
      categoryName !== "" &&
      destinationId == undefined
    ) {
      setPackageTypeList({
        label: categoryName,
        value: categoryId,
      });
    } else {
      setPackageTypeList({
        label: "",
        value: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  console.log(categoryId, "categoryId");
  console.log(packageTypeList, "packageTypeList");
  console.log(value, "pricing value");
  console.log(durationValue, "durationValue");

  const { packages_list = [], packages_total_list = [] } = useSelector(
    (state) => state.Packages
  );

  const packageDataTable =
    packages_list &&
    packages_list.datum &&
    packages_list.datum.packageList.length > 0
      ? packages_list.datum.packageList.map((data) => {
          return {
            destinationId: data.destinationId,
            itineraries: data.itineraries,
            days:
              data.itineraries.length > 0
                ? data.itineraries.length + " Days"
                : 0,
            nights:
              data.itineraries.length > 0
                ? parseFloat(data.itineraries.length - 1) + " Nights"
                : 0,
            startingFrom: data.lowestPrice
              ? "₹ " + parseFloat(data.lowestPrice + 2000)
              : "",
            Price: data.lowestPrice !== null ? "₹ " + data.lowestPrice : "₹ 0",
            packageCategoryId: data.packageCategoryId,
            packageCode: data.packageCode,
            hotels: data.packageIncludes ? data.packageIncludes.hotels : false,
            meals: data.packageIncludes ? data.packageIncludes.meals : false,
            transport: data.packageIncludes
              ? data.packageIncludes.transport
              : false,
            sightSeeing: data.packageIncludes
              ? data.packageIncludes.sightSeeing
              : false,
            packageName: data.packageName,
            imageUrl:
              data.thumbnailsImages && data.thumbnailsImages.length > 0
                ? data.thumbnailsImages[0].imageUrl
                : "",
            Duration: data.tourPlan,
            _id: data._id,
          };
        })
      : [];
  const packagePrice =
    packages_total_list &&
    packages_total_list.datum &&
    packages_total_list.datum.packageList.length > 0
      ? packages_total_list.datum.packageList.map((data) =>
          data.lowestPrice !== null ? data.lowestPrice : 0
        )
      : [];
  const maxPrice = packagePrice.length === 0 ? 0 : Math.max(...packagePrice);
  // const maxValuePrice = maxPrice !== undefined && maxPrice > 0 ? maxPrice : 0;

  const [query, setQuery] = useState("");
  // const [valueSelected, setValueSelected] = useState("");
  // const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [priceSelected, setPriceSelected] = useState(false);
  const [durationSelected, setDurationSelected] = useState(false);
  const [searchArrays, setSearchArrays] = useState([]);
  const [searchDestinationSelected, setSearchDestinationSelected] =
    useState(false);

  const handleChange = (e) => {
    const userInput = e.target.value;
    // const filtered = packageDataTable
    //   .filter((row) =>
    //     row.packageName.toLowerCase().includes(e.target.value.toLowerCase())
    //   )
    //   .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates
    setPackageLoading(true);
    setTimeout(() => {
      setPackageLoading(false);
    }, 3000);
    setSearchDestinationSelected(true);
    if (userInput !== "") {
      api
        .get(
          `/package/top-search-drop-down-data?searchFilter=${userInput}&isPackageFilter=${true}`
        )
        .then((res) => {
          // setFilteredSuggestions(res.data.data)
          setSearchArrays(
            res.data && res.data.data && res.data.data.data
              ? res.data.data.data
              : []
          );
          console.log(res.data, "response from search");
          return res.data;
        })
        .catch((error) => Promise.reject(error));
    } else {
      setSearchArrays([]);
      setSearchDestinationSelected(false);
    }
    setQuery(userInput);
    // setFilteredSuggestions(userInput ? filtered : []);
  };

  // const handleClick = (suggestion) => {
  //   setQuery(suggestion.destinationName);
  //   setValueSelected(suggestion.destinationName);
  //   setFilteredSuggestions([]);
  // };
  const { package_category_list = [] } = useSelector(
    (state) => state.Dashboard
  );
  const packageCategoryList =
    package_category_list &&
    package_category_list.queryResult &&
    package_category_list.queryResult.length > 0
      ? package_category_list.queryResult.map((data) => {
          return {
            label: data.packageCategoryName,
            description: data.description !== "" ? data.description : "",
            value: data._id,
          };
        })
      : [];
  const dropdownRef = useRef(null);

  // Close dropdown when clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setPriceSelected(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const durationRef = useRef(null);

  // Close dropdown when clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (durationRef.current && !durationRef.current.contains(event.target)) {
        setDurationSelected(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  console.log(searchArrays, "searchArrays");
  const packageRef = useRef(null);
  // Close dropdown when clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (packageRef.current && !packageRef.current.contains(event.target)) {
        setSearchDestinationSelected(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Packages | Plan mi trip</title>
        </MetaTags>
      </div>
      <Col
        md={24}
        sm={24}
        lg={24}
        xl={24}
        xxl={24}
        className="mr-[-6px] mt-[-20px]"
      >
        <div
          style={{
            width: "101%",
            marginLeft: "-6px",
          }}
        >
          {/* Slider contents with auto search fields */}
          <Slider {...settings} centerMode className="h-[100%] w-[100%]">
            {slides.map((slide) => (
              <div
                key={slide.id}
                className={
                  media == "md" || media == "sm" || media == "xs"
                    ? "h-[280px]"
                    : "h-[280px]"
                }
              >
                <h2
                  style={{
                    width: "100%",
                  }}
                >
                  {slide.content}
                </h2>
                <div
                  style={{
                    position: "absolute",
                    top: "0px",
                    bottom: "4px",
                    //   marginLeft: "1px",
                    width: "100%",
                    color: "#ffffff",
                    fontSize: "18px",
                    fontFamily: "Poppins",
                    fontWeight: 700,
                    //   zIndex: 20,
                    padding: "20px",
                    background: "#0000003d",
                  }}
                >
                  <Col
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    sm={24}
                    xs={24}
                    className="flex justify-center"
                  >
                    <Row
                      className={
                        media == "md" || media == "sm" || media == "xs"
                          ? "mt-[70px] flex justify-center"
                          : "w-[70%] mt-[60px] flex justify-center"
                      }
                    >
                      <div
                        className={
                          media == "xl" || media == "lg" || media == "xxl"
                            ? "mt-[-8px] w-[65%]"
                            : "mt-[-8px] w-[100%]"
                        }
                      >
                        {/* <Row
                      className={
                        media == "md" || media == "sm" || media == "xs"
                          ? "mt-[120px] flex justify-center"
                          : "w-[70%] mt-[110px] flex justify-center"
                      }
                    >
                      <div> */}
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="capitalize flex justify-center w-[100%] text-[24px] text-center mb-4"
                        >
                          {destinationData !== undefined &&
                          destinationData.destinationName !== undefined
                            ? destinationData.destinationName +
                              " Holidays Packages"
                            : "Holidays Packages"}{" "}
                        </h1>
                        {/* </div> */}
                        {/* </Row> */}
                        <Input
                          size={
                            media == "sm" || media == "xs" ? "small" : "large"
                          }
                          placeholder="Enter your packages!"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "65px",
                            // border: "0.5px solid lightgray",
                            padding:
                              media == "sm" || media == "xs"
                                ? "6px 10px"
                                : media == "md"
                                ? "6px 10px"
                                : "6px 12px",
                            borderRadius: "6px",
                            fontSize: "20px",
                            fontWeight: 700,
                          }}
                          prefix={
                            <FaLocationDot className="text-[20px] text-[#eb3e43] mr-2" />
                          }
                          className="input-label rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-red-400 transition"
                          suffix={
                            // valueSelected !== "" ? (
                            //   <CloseCircleOutlined
                            //     onClick={() => {
                            //       setValueSelected("");
                            //       setQuery("");
                            //     }}
                            //   />
                            // ) : (
                            //   ""
                            // )
                            <div className="text-[13px] packages-details-main-search-suffix">
                              <h1 className="mt-[-5px]">GO</h1>
                            </div>
                          }
                          name="query"
                          value={query}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                      {/* <AutoComplete
                        style={{
                          marginRight: "10px",
                          // fontSize: "11px",
                          fontFamily: "Poppins",
                          borderRadius: "8px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[60%]"
                      >
                        <Input
                          size="large"
                          // placeholder="Packages"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "65px",
                            border: "0.5px solid lightgray",
                            padding:
                              media == "sm" || media == "xs"
                                ? "6px 12px"
                                : media == "md"
                                ? "8px 10px"
                                : "8px 12px",
                            borderRadius: "6px",
                            fontSize: "22px",
                            fontWeight: 700,
                          }}
                          prefix={
                            <FaLocationDot className="text-[20px] text-[#eb3e43] mr-2" />
                          }
                          name="search"
                          suffix={
                            <div className="text-[13px] packages-main-search-suffix">
                              <h1 className="mt-[-11px]">GO</h1>
                            </div>
                          }
                          value={"Packages"}
                          // value={search}
                          // onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete> */}
                    </Row>
                  </Col>
                </div>
              </div>
            ))}
          </Slider>
          {searchDestinationSelected === false ? (
            ""
          ) : (
            <div className="w-[100%] relative" ref={packageRef}>
              <div
                style={{
                  zIndex: 900,
                  position: "absolute",
                  top:
                    media == "xl" || media == "lg" || media == "xxl"
                      ? "-113px"
                      : media == "md"
                      ? "-100px"
                      : media == "sm" || media == "xs"
                      ? "-100px"
                      : "-62px",
                  left:
                    media == "xl" || media == "lg" || media == "xxl"
                      ? "28.1%"
                      : media == "sm"
                      ? "28.3%"
                      : "33%",
                  width:
                    media == "xl" || media == "lg" || media == "xxl"
                      ? "45%"
                      : media == "sm"
                      ? "45%"
                      : "36%",
                }}
                className={
                  query !== "" && searchArrays.length > 0
                    ? "destination-modal-layout absolute bg-white rounded-xl shadow-lg z-10"
                    : query !== "" && searchArrays.length == 0
                    ? "packages-empty-modal-layout absolute bg-white rounded-xl shadow-lg z-10"
                    : query !== ""
                    ? "destination-modal-layout absolute bg-white rounded-xl shadow-lg z-10"
                    : ""
                }
              >
                {/* {query !== "" ? (
                  <div className="border border-b-1 pb-2 border-x-0 border-t-0 flex flex-row pl-6 text-start">
                    <h1
                      style={{
                        marginTop: "19px",
                        marginRight: "25px",
                        color: "black",
                      }}
                    >
                      <FaLocationDot className="text-[20px]" />
                    </h1>
                    <h1
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="text-[black] text-[16px] mt-[14px] font-normal"
                    >
                      Top Trending Packages
                    </h1>
                  </div>
                ) : (
                  ""
                )} */}
                {searchArrays !== undefined && searchArrays.length > 0 ? (
                  searchArrays.map((suggestion, index) => {
                    const imageUrl =
                      suggestion &&
                      suggestion.thumbnailsImages !== undefined &&
                      suggestion.thumbnailsImages.length > 0
                        ? suggestion.thumbnailsImages[0].imageUrl
                        : "";
                    const packageDataFromApi = {
                      hotels: suggestion.packageIncludes
                        ? suggestion.packageIncludes.hotels
                        : false,
                      meals: suggestion.packageIncludes
                        ? suggestion.packageIncludes.meals
                        : false,
                      transport: suggestion.packageIncludes
                        ? suggestion.packageIncludes.transport
                        : false,
                      sightSeeing: suggestion.packageIncludes
                        ? suggestion.packageIncludes.sightSeeing
                        : false,
                      packageName: suggestion.packageName,
                      _id: suggestion._id,
                      imageUrl:
                        suggestion.thumbnailsImages &&
                        suggestion.thumbnailsImages.length > 0
                          ? suggestion.thumbnailsImages[0].imageUrl
                          : "",
                    };
                    return (
                      <div
                        style={{
                          fontFamily: "Poppins",
                        }}
                        // to={{
                        //   pathname: `/package-details/${suggestion.packageName}`,
                        //   state: packageDataFromApi,
                        // }}
                        key={index}
                        onClick={() => {
                          if (
                            suggestion &&
                            suggestion.packageName !== undefined
                          ) {
                            history.push({
                              pathname: `/package-details/${suggestion.packageName}`,
                              state: packageDataFromApi,
                            });
                          }
                          if (
                            suggestion &&
                            suggestion.packageCategoryName !== undefined
                          ) {
                            dispatch(
                              loadPackagesList(
                                sortingList.value !== "" &&
                                  suggestion._id !== "" &&
                                  value &&
                                  value[1] > 0 &&
                                  durationValue &&
                                  durationValue[1] > 0
                                  ? "?sortFilter=" +
                                      sortingList.value +
                                      "&durationDays=" +
                                      Math.round(durationValue[0]) +
                                      "-" +
                                      Math.round(durationValue[1]) +
                                      "&priceRange=" +
                                      Math.round(value[0]) +
                                      "-" +
                                      Math.round(value[1]) +
                                      "&packageCatId=" +
                                      suggestion._id
                                  : sortingList.value !== "" &&
                                    suggestion._id === "" &&
                                    value &&
                                    value[1] === 0 &&
                                    durationValue &&
                                    durationValue[1] > 0
                                  ? "?durationDays=" +
                                    Math.round(durationValue[0]) +
                                    "-" +
                                    Math.round(durationValue[1]) +
                                    "&sortFilter=" +
                                    sortingList.value
                                  : sortingList.value !== "" &&
                                    suggestion._id === "" &&
                                    value &&
                                    value[1] > 0 &&
                                    durationValue &&
                                    durationValue[1] > 0
                                  ? "?durationDays=" +
                                    Math.round(durationValue[0]) +
                                    "-" +
                                    Math.round(durationValue[1]) +
                                    "&priceRange=" +
                                    Math.round(value[0]) +
                                    "-" +
                                    Math.round(value[1]) +
                                    "&sortFilter=" +
                                    sortingList.value
                                  : sortingList.value !== "" &&
                                    suggestion._id !== "" &&
                                    value &&
                                    value[1] === 0 &&
                                    durationValue &&
                                    durationValue[1] > 0
                                  ? "?durationDays=" +
                                    Math.round(durationValue[0]) +
                                    "-" +
                                    Math.round(durationValue[1]) +
                                    "&sortFilter=" +
                                    sortingList.value +
                                    "&packageCatId=" +
                                    suggestion._id
                                  : sortingList.value !== "" &&
                                    suggestion._id === "" &&
                                    value &&
                                    value[1] === 0 &&
                                    durationValue &&
                                    durationValue[1] == 0
                                  ? "?sortFilter=" + sortingList.value
                                  : sortingList.value !== "" &&
                                    suggestion._id !== "" &&
                                    value &&
                                    value[1] === 0 &&
                                    durationValue &&
                                    durationValue[1] == 0
                                  ? "?packageCatId=" +
                                    suggestion._id +
                                    "&sortFilter=" +
                                    sortingList.value
                                  : sortingList.value !== "" &&
                                    suggestion._id !== "" &&
                                    value &&
                                    value[1] > 0 &&
                                    durationValue &&
                                    durationValue[1] == 0
                                  ? "?packageCatId=" +
                                    suggestion._id +
                                    "?sortFilter=" +
                                    sortingList.value +
                                    "&priceRange=" +
                                    Math.round(value[0]) +
                                    "-" +
                                    Math.round(value[1])
                                  : ""
                              )
                            );
                            setSearchDestinationSelected(false);
                            setPackageTypeList({
                              label: suggestion.packageCategoryName,
                              value: suggestion._id,
                            });
                            setQuery(suggestion.packageCategoryName);
                          }
                          // handleClick(suggestion);
                        }}
                        className="flex justify-between pl-4 pb-4 pt-2 text-start border border-b-1 border-x-0 hover:bg-[#fff3f3] border-t-0 cursor-pointer"
                      >
                        <div
                          className={
                            media === "xl"
                              ? "flex"
                              : "mt-[10px] flex justify-between"
                          }
                        >
                          <div
                            className={
                              suggestion &&
                              suggestion.packageCategoryName !== undefined
                                ? "flex mt-[-4px]"
                                : "flex"
                            }
                          >
                            {suggestion &&
                            suggestion.packageCategoryName !== undefined ? (
                              <PiPackageBold className="text-[24px] xl:mt-[8px] border mt-[8px] text-[#eb3e43] border-lightgray-1 rounded-md" />
                            ) : (
                              <Image
                                // loading="lazy"
                                src={imageUrl}
                                preview={false}
                                width={40}
                                height={40}
                                className="border border-lightgray-1 mt-2 mb-2 rounded-md"
                              />
                            )}
                            {media === "xl" ? (
                              ""
                            ) : (
                              <p className="hover:text-[#eb3e43] mt-[6px] text-[14px] font-normal ml-4">
                                {" "}
                                {suggestion &&
                                suggestion.packageName !== undefined
                                  ? suggestion.packageName
                                  : suggestion.packageCategoryName !== undefined
                                  ? suggestion.packageCategoryName
                                  : ""}
                              </p>
                            )}
                          </div>
                          <div>
                            {media === "xl" ? (
                              <p
                                className={
                                  suggestion.packageCategoryName !== undefined
                                    ? "mt-[8px] hover:text-[#eb3e43] text-[14px] font-normal ml-4"
                                    : "mt-[5px] hover:text-[#eb3e43] text-[14px] font-normal ml-4"
                                }
                              >
                                {" "}
                                {suggestion &&
                                suggestion.packageName !== undefined
                                  ? suggestion.packageName
                                  : suggestion.packageCategoryName !== undefined
                                  ? suggestion.packageCategoryName
                                  : ""}
                              </p>
                            ) : (
                              ""
                            )}

                            {suggestion &&
                            suggestion.packageName !== undefined ? (
                              <p
                                className={
                                  media === "xl"
                                    ? "mt-[2px] ml-4 text-[11.5px] font-semibold text-[#eb3e43]"
                                    : "text-[11.5px] mt-[8px] ml-3 mr-3 font-semibold text-[#eb3e43]"
                                }
                              >
                                {suggestion &&
                                suggestion.packageName !== undefined
                                  ? suggestion.totalDayAndNight
                                  : ""}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : query !== "" && searchArrays.length === 0 ? (
                  <div className="h-[70px] absolute w-[100%] z-10">
                    {/* <div className="h-[70px] absolute w-[100%] bg-white rounded-2xl shadow-lg z-10"> */}
                    <h1
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="w-[100%] flex pl-4 mt-6 text-[14px] justify-center"
                    >
                      {packageLoading ? (
                        <Spin
                          indicator={
                            <LoadingOutlined style={{ fontSize: 40 }} spin />
                          }
                        />
                      ) : (
                        "No data found.."
                      )}
                    </h1>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
        <Row className="">
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            style={{
              zIndex: 0,
            }}
            className={
              media == "sm"
                ? "pr-[6%] pl-[6%]"
                : media == "xs"
                ? "pl-[30px]"
                : media == "md"
                ? "pr-[7%] pl-[7%]"
                : media == "lg"
                ? "pr-[10%] pl-[10%]"
                : media == "xxl"
                ? "pr-[11%] pl-[11%]"
                : "pr-[6.5%] pl-[6.5%]"
            }
          >
            <Breadcrumb
              style={{
                fontFamily: "Poppins",
                color: "blue",
                fontSize: "12px",
              }}
              items={[
                {
                  href: "/",
                  title: "Home",
                  separator: ">",
                },
                {
                  // path: "/user",
                  title: "Packages",
                },
              ]}
            />
          </Col>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm"
                ? "pr-[6%] pl-[6%] mt-4"
                : media == "xs"
                ? "pl-[30px] mt-4"
                : media == "md"
                ? "pr-[7%] pl-[7%] mt-4"
                : media == "lg"
                ? "pr-[10%] pl-[10%] mt-4"
                : media == "xxl"
                ? "pr-[11%] pl-[11%] mt-4"
                : "pr-[6.5%] pl-[6.5%] mt-4"
            }
          >
            <Row
              style={{
                zIndex: 10,
                marginBottom: "-15px",
                // border: "1px solid #ff373c29",
                // border: "1.5px solid #e63946",
                // border: "2px solid #30303030",
                // border: "2px solid #ffc0ba",
              }}
              className="pt-4 pb-3 pl-4 pr-10 border border-1 shadow-md border-[#d8d6d6] rounded-md"
              // className="pt-4 pb-3 pl-4 pr-10 border border-2 border-[#e63946] rounded-md"
            >
              <Col
                md={5}
                sm={24}
                xs={24}
                lg={5}
                xl={5}
                xxl={5}
                className="flex flex-col p-1"
              >
                {/* <h1
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="mt-[-20px] mb-[5px] text-[black] text-[14px] font-extrabold"
                >
                  Sorted by
                </h1> */}
                <Select
                  name="sortingList"
                  value={sortingList}
                  onChange={(e, options) => {
                    setSortingList({
                      value: e,
                      label: options && options.label,
                    });
                    if (destinationId !== "" && destinationId !== undefined) {
                      dispatch(
                        loadPackagesList(
                          destinationId !== "" && e !== ""
                            ? "?destinationIds=" +
                                destinationId +
                                "&sortFilter=" +
                                e
                            : ""
                        )
                      );
                    } else {
                      dispatch(
                        loadPackagesList(
                          e !== "" &&
                            packageTypeList.value !== "" &&
                            value &&
                            value[1] > 0 &&
                            durationValue &&
                            durationValue[1] > 0
                            ? "?sortFilter=" +
                                e +
                                "&durationDays=" +
                                Math.round(durationValue[0]) +
                                "-" +
                                Math.round(durationValue[1]) +
                                "&priceRange=" +
                                Math.round(value[0]) +
                                "-" +
                                Math.round(value[1]) +
                                "&packageCatId=" +
                                packageTypeList.value
                            : e !== "" &&
                              packageTypeList.value === "" &&
                              value &&
                              value[1] === 0 &&
                              durationValue &&
                              durationValue[1] > 0
                            ? "?durationDays=" +
                              Math.round(durationValue[0]) +
                              "-" +
                              Math.round(durationValue[1]) +
                              "&sortFilter=" +
                              e
                            : e !== "" &&
                              packageTypeList.value === "" &&
                              value &&
                              value[1] > 0 &&
                              durationValue &&
                              durationValue[1] > 0
                            ? "?durationDays=" +
                              Math.round(durationValue[0]) +
                              "-" +
                              Math.round(durationValue[1]) +
                              "&priceRange=" +
                              Math.round(value[0]) +
                              "-" +
                              Math.round(value[1]) +
                              "&sortFilter=" +
                              e
                            : e !== "" &&
                              packageTypeList.value !== "" &&
                              value &&
                              value[1] === 0 &&
                              durationValue &&
                              durationValue[1] > 0
                            ? "?durationDays=" +
                              Math.round(durationValue[0]) +
                              "-" +
                              Math.round(durationValue[1]) +
                              "&sortFilter=" +
                              e +
                              "&packageCatId=" +
                              packageTypeList.value
                            : e !== "" &&
                              packageTypeList.value === "" &&
                              value &&
                              value[1] === 0 &&
                              durationValue &&
                              durationValue[1] == 0
                            ? "?sortFilter=" + e
                            : e !== "" &&
                              packageTypeList.value !== "" &&
                              value &&
                              value[1] === 0 &&
                              durationValue &&
                              durationValue[1] == 0
                            ? "?packageCatId=" +
                              packageTypeList.value +
                              "&sortFilter=" +
                              e
                            : e !== "" &&
                              packageTypeList.value !== "" &&
                              value &&
                              value[1] > 0 &&
                              durationValue &&
                              durationValue[1] == 0
                            ? "?packageCatId=" +
                              packageTypeList.value +
                              "?sortFilter=" +
                              e +
                              "&priceRange=" +
                              Math.round(value[0]) +
                              "-" +
                              Math.round(value[1])
                            : ""
                        )
                      );
                    }
                  }}
                  placeholder="Select Sorting"
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    borderRadius: "6px",
                    border: "1px solid #f7f7f7e0",
                  }}
                  allowClear
                  // suffixIcon={
                  //   sortingList.value !== "" ? (
                  //     <CloseOutlined
                  //       onClick={() => {
                  //         setSortingList([]);
                  //         dispatch(
                  //           loadPackagesList(
                  //             value && value[1] > 0 && durationValue !== ""
                  //               ? "&priceRange=" +
                  //                   Math.round(value[0]) +
                  //                   "-" +
                  //                   Math.round(value[1]) +
                  //                   "&durationDays=" +
                  //                   Math.round(durationValue[0]) +
                  //                   "-" +
                  //                   Math.round(durationValue[1])
                  //               : value && value === 0 && durationValue !== ""
                  //               ? "&durationDays=" +
                  //                 Math.round(durationValue[0]) +
                  //                 "-" +
                  //                 Math.round(durationValue[1])
                  //               : value && value[1] > 0 && durationValue === ""
                  //               ? "?priceRange=" +
                  //                 Math.round(value[0]) +
                  //                 "-" +
                  //                 Math.round(value[1])
                  //               : ""
                  //           )
                  //         );
                  //       }}
                  //     />
                  //   ) : (
                  //     <DownOutlined />
                  //   )
                  // }
                  options={[
                    {
                      label: "Low to High",
                      value: "low-to-high",
                    },
                    {
                      label: "High to Low",
                      value: "high-to-low",
                    },
                    {
                      label: "Newest First",
                      value: "newest-first",
                    },
                    {
                      label: "Oldest First",
                      value: "oldest-first",
                    },
                  ]}
                  // suffixIcon={<SearchOutlined />}
                  className={
                    media === "sm" || media === "xs"
                      ? "w-[100%] h-[40px]"
                      : "w-[90%] h-[40px]"
                  }
                />
              </Col>
              <Col
                md={5}
                sm={24}
                xs={24}
                lg={5}
                xl={5}
                xxl={5}
                className="flex flex-col p-1"
              >
                {/* <h1
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="mt-[-20px] mb-[5px] text-[black] text-[14px] font-extrabold"
                >
                  Package Type
                </h1> */}
                <Select
                  name="packageTypeList"
                  value={packageTypeList}
                  onChange={(e, options) => {
                    setPackageTypeList({
                      value: e,
                      label: options && options.label,
                    });
                    if (destinationId !== "" && destinationId !== undefined) {
                      dispatch(
                        loadPackagesList(
                          destinationId !== "" && e !== ""
                            ? "?destinationIds=" +
                                destinationId +
                                "&sortFilter=" +
                                e
                            : ""
                        )
                      );
                    } else {
                      dispatch(
                        loadPackagesList(
                          e !== "" &&
                            sortingList.value !== "" &&
                            value &&
                            value[1] > 0 &&
                            durationValue &&
                            durationValue[1] > 0
                            ? "?sortFilter=" +
                                sortingList.value +
                                "&durationDays=" +
                                Math.round(durationValue[0]) +
                                "-" +
                                Math.round(durationValue[1]) +
                                "&priceRange=" +
                                Math.round(value[0]) +
                                "-" +
                                Math.round(value[1]) +
                                "&packageCatId=" +
                                e
                            : e !== "" &&
                              sortingList.value === "" &&
                              value &&
                              value[1] === 0 &&
                              durationValue &&
                              durationValue[1] > 0
                            ? "?durationDays=" +
                              Math.round(durationValue[0]) +
                              "-" +
                              Math.round(durationValue[1]) +
                              "&packageCatId=" +
                              e
                            : e !== "" &&
                              sortingList.value === "" &&
                              value &&
                              value[1] > 0 &&
                              durationValue &&
                              durationValue[1] > 0
                            ? "?durationDays=" +
                              Math.round(durationValue[0]) +
                              "-" +
                              Math.round(durationValue[1]) +
                              "&priceRange=" +
                              Math.round(value[0]) +
                              "-" +
                              Math.round(value[1]) +
                              "&packageCatId=" +
                              packageTypeList.value
                            : e !== "" &&
                              sortingList.value !== "" &&
                              value &&
                              value[1] === 0 &&
                              durationValue &&
                              durationValue[1] > 0
                            ? "?durationDays=" +
                              Math.round(durationValue[0]) +
                              "-" +
                              Math.round(durationValue[1]) +
                              "&sortFilter=" +
                              sortingList.value +
                              "&packageCatId=" +
                              e
                            : e !== "" &&
                              sortingList.value === "" &&
                              value &&
                              value[1] === 0 &&
                              durationValue &&
                              durationValue[1] == 0
                            ? "?packageCatId=" + e
                            : e !== "" &&
                              sortingList.value !== "" &&
                              value &&
                              value[1] === 0 &&
                              durationValue &&
                              durationValue[1] == 0
                            ? "?packageCatId=" +
                              e +
                              "&sortFilter=" +
                              sortingList.value
                            : e !== "" &&
                              sortingList.value !== "" &&
                              value &&
                              value[1] > 0 &&
                              durationValue &&
                              durationValue[1] == 0
                            ? "?packageCatId=" +
                              e +
                              "?sortFilter=" +
                              sortingList.value +
                              "&priceRange=" +
                              Math.round(value[0]) +
                              "-" +
                              Math.round(value[1])
                            : ""
                        )
                      );
                    }
                  }}
                  placeholder="Package Type"
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    borderRadius: "6px",
                    border: "1px solid #f7f7f7e0",
                  }}
                  allowClear
                  // suffixIcon={
                  //   sortingList.value !== "" ? (
                  //     <CloseOutlined
                  //       onClick={() => {
                  //         setSortingList([]);
                  //         dispatch(
                  //           loadPackagesList(
                  //             value && value[1] > 0 && durationValue !== ""
                  //               ? "&priceRange=" +
                  //                   Math.round(value[0]) +
                  //                   "-" +
                  //                   Math.round(value[1]) +
                  //                   "&durationDays=" +
                  //                   Math.round(durationValue[0]) +
                  //                   "-" +
                  //                   Math.round(durationValue[1])
                  //               : value && value === 0 && durationValue !== ""
                  //               ? "&durationDays=" +
                  //                 Math.round(durationValue[0]) +
                  //                 "-" +
                  //                 Math.round(durationValue[1])
                  //               : value && value[1] > 0 && durationValue === ""
                  //               ? "?priceRange=" +
                  //                 Math.round(value[0]) +
                  //                 "-" +
                  //                 Math.round(value[1])
                  //               : ""
                  //           )
                  //         );
                  //       }}
                  //     />
                  //   ) : (
                  //     <DownOutlined />
                  //   )
                  // }
                  options={packageCategoryList}
                  // suffixIcon={<SearchOutlined />}
                  className={
                    media === "sm" || media === "xs"
                      ? "w-[100%] h-[40px]"
                      : "w-[90%] h-[40px]"
                  }
                />
              </Col>
              <Col
                md={5}
                sm={24}
                xs={24}
                lg={5}
                xl={5}
                xxl={5}
                className={
                  media === "sm" || media === "xs"
                    ? "pl-2 pr-2 mb-2"
                    : "pl-4 pr-4"
                }
                ref={dropdownRef}
              >
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => {
                    setDurationSelected(false);
                    setPriceSelected(!priceSelected);
                  }}
                  className="w-[100%] relative cursor-pointer mt-1 pl-3 pr-3 pt-2 font-label h-[40px] relative flex justify-between border border-1 rounded-md"
                >
                  Price <FaAngleDown className="text-[16px] mt-1" />
                </div>

                <div
                  className={
                    priceSelected === true
                      ? "packages-filter-modal-layout absolute w-[100%] bg-[white] rounded-2xl shadow-lg z-10"
                      : ""
                  }
                  style={{
                    zIndex: 1000,
                  }}
                >
                  {priceSelected === true ? (
                    <div
                      className={
                        media == "sm" || media == "xs"
                          ? "pt-6 pb-2 pr-6 pl-6 rounded-md w-[100%] mt-6 mb-3"
                          : "pt-6 pb-2 pr-6 pl-6 rounded-md w-[100%] pl-4"
                      }
                      style={{
                        zIndex: 1000,
                      }}
                    >
                      <h1
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[14px] mt-[-4px] font-extrabold"
                      >
                        Price
                      </h1>
                      {/* Display Values Above the Slider */}
                      <div className="w-[100%] flex justify-between">
                        <div className="flex">
                          <h1
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                            }}
                          >
                            ₹ {value.length > 0 && value[0]}
                          </h1>
                          {value.length > 1 && value[1] > 0 ? (
                            <p className="ml-[2px] mt-[-1px] mr-[2px]">
                              {" - "}
                            </p>
                          ) : (
                            ""
                          )}
                          {value.length > 1 && value[1] > 0 ? (
                            <h1
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "14px",
                              }}
                            >
                              ₹ {value.length > 0 && value[1]}
                            </h1>
                          ) : (
                            ""
                          )}
                        </div>
                        <div>
                          <h1
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                            }}
                          >
                            ₹ {maxPrice !== undefined ? maxPrice : ""}
                          </h1>
                        </div>
                      </div>
                      <RangeSlider
                        id="range-slider"
                        min={0}
                        max={maxPrice}
                        step={10}
                        value={value}
                        onInput={(e) => {
                          setValue(e);
                          if (e) {
                            dispatch(
                              loadPackagesList(
                                e !== "" &&
                                  sortingList.value !== "" &&
                                  durationValue &&
                                  durationValue[1] > 0 &&
                                  packageTypeList.value !== ""
                                  ? "?sortFilter=" +
                                      sortingList.value +
                                      "&packageCatId=" +
                                      packageTypeList.value +
                                      "&priceRange=" +
                                      Math.round(e[0]) +
                                      "-" +
                                      Math.round(e[1]) +
                                      "&durationDays=" +
                                      Math.round(durationValue[0]) +
                                      "-" +
                                      Math.round(durationValue[1])
                                  : e !== "" &&
                                    sortingList.value === "" &&
                                    durationValue &&
                                    durationValue[1] > 0 &&
                                    packageTypeList.value !== ""
                                  ? "?priceRange=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1]) +
                                    "&durationDays=" +
                                    Math.round(durationValue[0]) +
                                    "-" +
                                    Math.round(durationValue[1]) +
                                    "&packageCatId=" +
                                    packageTypeList.value
                                  : e !== "" &&
                                    sortingList.value !== "" &&
                                    durationValue === "" &&
                                    packageTypeList.value !== ""
                                  ? "?priceRange=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1]) +
                                    "&sortFilter=" +
                                    sortingList.value +
                                    "&packageCatId=" +
                                    packageTypeList.value
                                  : e !== "" &&
                                    sortingList.value === "" &&
                                    durationValue === "" &&
                                    packageTypeList.value === ""
                                  ? "?priceRange=" + Math.round(e[0]) + "-"
                                  : e !== "" &&
                                    sortingList.value !== "" &&
                                    durationValue === "" &&
                                    packageTypeList.value === ""
                                  ? "?priceRange=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1]) +
                                    "&sortFilter=" +
                                    sortingList.value
                                  : e !== "" &&
                                    sortingList.value !== "" &&
                                    durationValue &&
                                    durationValue[1] > 0 &&
                                    packageTypeList.value === ""
                                  ? "?priceRange=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1]) +
                                    "&sortFilter=" +
                                    sortingList.value +
                                    "&durationDays=" +
                                    Math.round(durationValue[0]) +
                                    "-" +
                                    Math.round(durationValue[1])
                                  : ""
                              )
                            );
                          }
                        }}
                        className="text-[#eb3e43] bg-[#eb3e43] margin-lg mt-5"
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
              <Col
                md={5}
                sm={24}
                xs={24}
                lg={5}
                xl={5}
                xxl={5}
                className={
                  media === "sm" || media === "xs" ? "pl-2 pr-2" : "pl-4 pr-4"
                }
                ref={durationRef}
              >
                {/* {media == "sm" || media == "xs" ? (
                  ""
                ) : (
                  <Divider
                    type="vertical"
                    style={{
                      borderWidth: "0.1px",
                    }}
                    className="text-[lightgray] ml-2 mt-[-24px] mb-[-14px] h-[130px]"
                  />
                )} */}
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => {
                    setDurationSelected(!durationSelected);
                    setPriceSelected(false);
                  }}
                  className="w-[100%] rounded-md pl-3 mt-1 pt-2 pr-3 font-label h-[40px] relative flex justify-between cursor-pointer border border-1"
                >
                  Duration <FaAngleDown className="text-[16px] mt-1" />
                </div>
                <div
                  className={
                    durationSelected === true
                      ? "packages-filter-modal-layout absolute w-[100%] bg-[white] rounded-2xl shadow-lg z-10"
                      : ""
                  }
                  style={{
                    zIndex: 1000,
                  }}
                >
                  {durationSelected === true ? (
                    <div
                      className={
                        media == "sm" || media == "xs"
                          ? "pt-6 pb-2 pr-6 pl-6 rounded-md w-[100%] mt-5 mb-4"
                          : "pt-6 pb-2 pr-6 pl-6 rounded-md w-[100%] pl-4"
                      }
                      style={{
                        zIndex: 1000,
                      }}
                    >
                      <h1
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="text-[14px] mt-[-4px] font-extrabold"
                      >
                        Duration
                      </h1>
                      <div className="w-[100%] flex justify-between">
                        <h1
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "15px",
                          }}
                        >
                          {durationValue.length > 0 &&
                            Math.round(durationValue[0])}
                        </h1>
                        <h1
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "15px",
                          }}
                        >
                          {durationValue.length > 0 &&
                            Math.round(durationValue[1])}
                        </h1>
                      </div>
                      <RangeSlider
                        min={0}
                        max={10}
                        // step={10}
                        value={durationValue}
                        onInput={(e) => {
                          setDurationValue(e);
                          if (e) {
                            dispatch(
                              loadPackagesList(
                                e !== "" &&
                                  sortingList.value !== "" &&
                                  value &&
                                  value[1] > 0 &&
                                  packageTypeList.value !== ""
                                  ? "?sortFilter=" +
                                      sortingList.value +
                                      "&durationDays=" +
                                      Math.round(e[0]) +
                                      "-" +
                                      Math.round(e[1]) +
                                      "&priceRange=" +
                                      Math.round(value[0]) +
                                      "-" +
                                      Math.round(value[1]) +
                                      "&packageCatId=" +
                                      packageTypeList.value
                                  : e !== "" &&
                                    sortingList.value === "" &&
                                    value &&
                                    value[1] > 0 &&
                                    packageTypeList.value !== ""
                                  ? "?durationDays=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1]) +
                                    "&priceRange=" +
                                    Math.round(value[0]) +
                                    "-" +
                                    Math.round(value[1]) +
                                    "&packageCatId=" +
                                    packageTypeList.value
                                  : e !== "" &&
                                    sortingList.value !== "" &&
                                    value &&
                                    value === 0 &&
                                    packageTypeList.value !== ""
                                  ? "?durationDays=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1]) +
                                    "&sortFilter=" +
                                    sortingList.value +
                                    "&packageCatId=" +
                                    packageTypeList.value
                                  : e !== "" &&
                                    sortingList.value === "" &&
                                    value &&
                                    value === 0 &&
                                    packageTypeList.value !== ""
                                  ? "?durationDays=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1]) +
                                    "&packageCatId=" +
                                    packageTypeList.value
                                  : e !== "" &&
                                    sortingList.value === "" &&
                                    value &&
                                    value === 0 &&
                                    packageTypeList.value === ""
                                  ? "?durationDays=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1])
                                  : e !== "" &&
                                    sortingList.value !== "" &&
                                    value &&
                                    value === 0 &&
                                    packageTypeList.value === ""
                                  ? "?durationDays=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1]) +
                                    "&sortFilter=" +
                                    sortingList.value
                                  : e !== "" &&
                                    sortingList.value !== "" &&
                                    value &&
                                    value[1] > 0 &&
                                    packageTypeList.value === ""
                                  ? "?durationDays=" +
                                    Math.round(e[0]) +
                                    "-" +
                                    Math.round(e[1]) +
                                    "&sortFilter=" +
                                    sortingList.value +
                                    "&priceRange=" +
                                    Math.round(value[0]) +
                                    "-" +
                                    Math.round(value[1])
                                  : ""
                              )
                            );
                          }
                        }}
                        id="range-slider"
                        className="margin-lg mt-5"
                        step="any"
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* } */}
              </Col>
              <Col
                md={4}
                sm={24}
                xs={24}
                lg={4}
                xl={4}
                xxl={4}
                className={
                  media === "sm" || media === "xs" ? "pl-0 pr-4" : "pl-4 pr-4"
                }
              >
                {/* {media == "sm" || media == "xs" ? (
                  ""
                ) : (
                  <Divider
                    type="vertical"
                    style={{
                      borderWidth: "0.1px",
                    }}
                    className="text-[lightgray] ml-2 mt-[-24px] mb-[-14px] h-[130px]"
                  />
                )} */}
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => {
                    setDurationSelected(false);
                    setPriceSelected(false);
                    setSortingList({
                      label: "Newest First",
                      value: "newest-first",
                    });
                    setPackageTypeList([]);
                    setValue([0, maxPrice]);
                    setDurationValue([0, 2]);
                    dispatch(loadPackagesList());
                  }}
                  className="text-[#eb3e43] flex md:justify-end xl:justify-end lg:justify-end xxl:justify-end w-[100%] pl-3 mt-1 pt-2 pr-3 font-label cursor-pointer font-semibold"
                >
                  Reset All
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row
          className={
            media == "sm"
              ? "pr-[5%] pl-[5%] mt-[25px]"
              : media == "xs"
              ? "pl-[30px] mt-[25px]"
              : media == "md"
              ? "pr-[5%] pl-[5%] mt-[25px]"
              : media == "lg"
              ? "pr-[7%] pl-[8%] mt-[25px]"
              : media == "xxl"
              ? "pr-[9.5%] pl-[10%] mt-[25px]"
              : "pr-[4%] pl-[5%] mt-[25px]"
          }
        >
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <PackageDetails destinationData={destinationData} />
          </Col>
        </Row>
        {/* <Row>
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <SubBanner />
          </Col>
        </Row>
        <Row>
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <BannerContent />
          </Col>
        </Row>
        <Row>
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <NewLaunches />
          </Col>
        </Row>
        <Row>
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <Wonders />
          </Col>
        </Row>
        <Row>
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <HolidaPackages />
          </Col>
        </Row>
       

        <Row>
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <Benefits />
          </Col>
        </Row>
        <Row>
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <TravellerReview />
          </Col>
        </Row>
        <Row>
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <ReadingCorners />
          </Col>
        </Row> */}

        <Modal
          open={chatModal}
          title=""
          maskClosable={false}
          onClose={() => setChatModal(false)}
          // onCancel={() => setChatModal(false)}
          // onCancel={false}
          closable
          footer={null}
          closeIcon={
            <CloseOutlined
              onClick={() => setChatModal(false)}
              className="text-[#ffffff]"
            />
          }
          width={600}
        >
          {/* <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          /> */}
          <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
            <div className="w-[107%] ml-[-20px] mt-[-16px] h-[200px] global-modal-img rounded-md">
              <Row>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={12}
                  sm={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="p-3"
                >
                  <h2 className="text-[#ffffff]">
                    Don't miss out on our exclusive deals & insider only offers!
                  </h2>
                  <div className="text-[#ffffff] mt-2">
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      5 years of Experience in India
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Packages across 50 + Countries
                    </div>
                    <div className="flex">
                      <p>
                        <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                      </p>
                      Best Travel Partner of India
                    </div>
                  </div>
                </Col>
                <Col md={12} sm={12} lg={12} xl={12} xxl={12}></Col>
              </Row>
            </div>
          </Col>

          {/* <Collapse
            items={paymentFaqList}
            expandIcon={<DownCircleOutlined />}
            expandIconPosition="right"
            className="font-semibold"
            bordered
            style={{
              fontFamily: "Poppins",
            }}
          /> */}
        </Modal>
        <FloatButton
          className="w-[50px] h-[50px]"
          type="primary"
          style={{
            margin: "-7px",
          }}
          onClick={() => setChatModal(!chatModal)}
          icon={<CommentOutlined />}
        />
      </Col>
    </React.Fragment>
  );
};

Packages.propTypes = {
  location: PropTypes.any,
};

export default withRouter(Packages);
